import React, { useEffect, useState } from 'react';
import { _$, _addClass, _removeClass } from '../../controllers/dom';
import { locales } from '../../translations/locales';

const Logo = (props) => {
    const { text, button, load, locale } = props;
    const [count, setCount] = useState(0);

    useEffect(() => {
        _addClass('modrp', 'modrp');
        _removeClass('modrp', 'bg-dark');
        setCount(+1);
        const alwaysOnDisplay = (n) => {
            if (_$('logo') && n === count && load) {
                load();
            }
        };
        setTimeout(() => alwaysOnDisplay(count), 5000);
    }, [count, load]);

    return (
        <div className='textFull w-100'>
            <div>
                <img src="/images/modrp.webp" className="as-logo" alt="ALERTES SPÉCIALES" />
                <span className="as-cadre-r-beta">MODULE RP</span>
            </div>
            <div>
                <h3 className='text-danger'>Extension Alertes Spéciales | MOD RP</h3>
            </div>
            <div className='m-5 inline-flex' id='logo'>
                <div className='alert alert-warning'>
                    {
                        text === 'connected' ?
                            (<div
                                className='btn btn-sm btn-success'
                                onClick={() => load()}
                            >
                                Charger le module RP
                            </div>) :
                            <h6>{text || 'Chargement'}</h6>
                    }
                    {button &&
                        (<div
                            className='btn btn-sm btn-warning'
                            data-toggle={`modal`}
                            data-target={`#modal`}
                        >
                            {locales[locale].session.logSign}
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Logo;
